import { useContext, useEffect, useState } from 'react';
import invariant from 'ts-invariant';
import { getWaysteContext } from '../context/WaysteContext';
export function useCurrentUserProfile(override) {
    const context = useContext(getWaysteContext());
    const client = override || context.client;
    invariant(!!client, 'Could not find "client" in the context or passed in as an option. ' +
        'Wrap the root component in an <WaysteProvider>, or pass an WaysteClient ' +
        'instance in via options.');
    const [profile, setProfile] = useState(client.profile().currentUserProfile);
    useEffect(() => {
        const profileSub = client.profile().currentUserProfileObservable.subscribe((profile) => {
            setProfile(profile || null);
        });
        return () => {
            profileSub.unsubscribe();
        };
    }, [client]);
    return {
        profile,
    };
}
//# sourceMappingURL=useCurrentUserProfile.js.map